import { posthog } from './analytics';
import { getKeyValue, removeKeyValue, storeKeyValue } from './kvstore';
const DEBUG = false;
function log(msg) {
    if (DEBUG)
        console.log(msg);
}
// store the key/value pair for optionally expires number of seconds
export const storeValue = async (key, value, expires) => {
    if (typeof window === 'undefined' || typeof localStorage === 'undefined')
        return;
    try {
        sessionStorage.setItem(key, JSON.stringify({
            value,
            expires: expires ? Math.floor(new Date().getTime() / 1000) + expires : null
        }));
        log(`sessionStorage[${key}] <- ${value}`);
    }
    catch (e) {
        console.log(`Error storing ${key} in session storage: ${e}`);
        posthog.capture(`Error storing in session storage`, { key, error: e });
    }
    try {
        localStorage.setItem(key, JSON.stringify({
            value,
            expires: expires ? Math.floor(new Date().getTime() / 1000) + expires : null
        }));
        log(`localStorage[${key}] <- ${value}`);
    }
    catch (e) {
        console.log(`Error storing ${key} in local storage: ${e}`);
        posthog.capture(`Error storing in local storage`, { key, error: e });
    }
    try {
        const success = await storeKeyValue(key, JSON.stringify({
            value,
            expires: expires ? Math.floor(new Date().getTime() / 1000) + expires : null
        }));
        if (!success)
            console.log(`Failed to store ${key} in indexedDb`);
    }
    catch (e) {
        console.log(`Error storing ${key} in indexedDb: ${e}`);
        posthog.capture(`Error storing in indexedDb`, { key, error: e });
    }
};
export const getValue = async (key) => {
    try {
        const str = sessionStorage.getItem(key);
        if (str) {
            const data = JSON.parse(str);
            if (!data.expires || (data.expires && new Date(data.expires * 1000) > new Date())) {
                log(`cookie[${key}] -> ${data.value}`);
                return data.value;
            }
        }
    }
    catch (e) {
        console.log(`Error getting ${key} from session storage: ${e}`);
        posthog.capture(`Error getting from session storage`, { key, error: e });
    }
    try {
        const str = localStorage.getItem(key);
        if (str) {
            const data = JSON.parse(str);
            if (!data.expires || (data.expires && new Date(data.expires * 1000) > new Date())) {
                log(`localStorage[${key}] -> ${data.value}`);
                return data.value;
            }
        }
    }
    catch (e) {
        console.log(`Error getting ${key} from local storage: ${e}`);
        posthog.capture(`Error getting from local storage`, { key, error: e });
    }
    try {
        const str = await getKeyValue(key);
        if (str) {
            const data = JSON.parse(str);
            if (!data.expires || (data.expires && new Date(data.expires * 1000) > new Date())) {
                log(`indexDb[${key}] -> ${data.value}`);
                return data.value;
            }
        }
    }
    catch (e) {
        console.log(`Error getting ${key} from indexedDb storage: ${e}`);
        posthog.capture(`Error getting from indexedDb`, { key, error: e });
    }
    return null;
};
export const clearValue = async (key) => {
    if (typeof window === 'undefined' || typeof localStorage === 'undefined')
        return;
    try {
        sessionStorage.removeItem(key);
    }
    catch (e) {
        console.log(`Error removing ${key} from session storage: ${e}`);
        posthog.capture(`Error removing from session storage`, { key, error: e });
    }
    try {
        localStorage.removeItem(key);
    }
    catch (e) {
        console.log(`Error removing ${key} from local storage: ${e}`);
        posthog.capture(`Error removing from local storage`, { key, error: e });
    }
    try {
        await removeKeyValue(key);
    }
    catch (e) {
        console.log(`Error getting ${key} from indexedDb storage: ${e}`);
        posthog.capture(`Error removing from indexedDb`, { key, error: e });
    }
};
export const refreshValue = async (key, expires) => {
    const value = await getValue(key);
    if (value)
        await storeValue(key, value, expires);
    return value;
};
